module.exports = __webpack_public_path__ + "7b3baea49c51c7bc79451f3894f4bcbc.png";